<template>
  <Modal v-model="shippingWarehouseModal" :title="shippingWarehouseTitle" :mask-closable="false"
    :class-name="operationType === 'platformOrder' ? 'commonModalStyles' : ''"
    :width="shippingWarehouseWidth" @on-visible-change="shippingWarehouseChange">
    <!--平台订单详情匹配发货仓库-->
    <template v-if="operationType === 'platformDetails'">
      <Form :label-width="100" @submit.native.prevent>
        <Row type="flex">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000668')">
              <Select v-model="ymsWarehouseId" filterable style="width: 300px;">
                <Option v-for="item in shippingWarehouseList" :disabled="item.availableNumber<=0"
                  :value="item.ymsWarehouseId" :key="item.ymsWarehouseId" :label="item.name">
                  <div class="flex align-items-center justify-content-between">
                    <span :class="item.availableNumber<=0 ? '' : 'color-333'">{{ item.name }}</span>
                    <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + (item.availableNumber || 0) + '）' }}</span>
                  </div>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
    <!--平台订单列表匹配商品发货仓-->
    <template v-else>
      <div class="shippingWarehouse_box" v-for="(ele, index) in shippingWarehouseData">
        <div class="flex width_370 pr20">
          <div class="img_box">
            <img :src="ele.primaryImage" alt="">
          </div>
          <div class="ml12" style="flex: 1;">
            <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
            <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
            <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
            <p class="distributorThemeColor">{{ ele.specifications }}</p>
          </div>
        </div>
        <div class="flex align-items-center" style="flex:1">
          <span class="red-dot">{{ $t('key1005943') }}</span>
          <Select v-model="ele.ymsWarehouseId" filterable style="width: 280px;" @on-open-change="(value) => openChange(value, ele, index)">
            <Option v-for="item in ele.ymsWarehouseList" :disabled="item.availableNumber<=0"
              :value="item.ymsWarehouseId" :key="item.ymsWarehouseId" :label="item.name">
              <div class="flex align-items-center justify-content-between">
                <span :class="item.availableNumber<=0 ? '' : 'color-333'">{{ item.name }}</span>
                <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + (item.availableNumber || 0) + '）' }}</span>
              </div>
            </Option>
          </Select>
        </div>
      </div>
    </template>
    <template #footer>
      <Button @click="shippingWarehouseModal=false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="shippingWarehouseBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getProductShippingWarehouseInventory} from "@/utils/common";

export default {
  name: 'shippingWarehouseModal',
  mixins: [Mixin],
  data() {
    return {
      shippingWarehouseModal: false,
      ymsWarehouseId: null,
      shippingWarehouseList: [],
      operationType: null,
      shippingWarehouseTitle: '',
      shippingWarehouseWidth: 500,
      shippingWarehouseData: [],
      ymsPlatformOrderId: null,
      ymsPlatformOrderTransactionId: null,
    };
  },
  methods: {
    // 初始化数据
    initShippingWarehouseData(obj, type, ymsPlatformOrderId) {
      let titleObj = {
        platformDetails: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005939'),
        platformOrder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005940')
      };
      this.operationType = type;
      this.shippingWarehouseTitle = titleObj[type];
      this.shippingWarehouseWidth = type === 'platformDetails' ? 500 : 800;
      if (obj) {
        switch (type) {
          case 'platformDetails':
            this.ymsPlatformOrderId = ymsPlatformOrderId;
            this.ymsPlatformOrderTransactionId = obj.ymsPlatformOrderTransactionId;
            getProductShippingWarehouseInventory([obj.ymsProductGoodsId]).then((data) => {
              if (data.length > 0) {
                data.map((item) => {
                  if (item.ymsProductGoodsId === obj.ymsProductGoodsId) {
                    let list = item.productDeliverWarehouseResultBos || [];
                    this.shippingWarehouseList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                  }
                });
              }
            });
            break;
          case 'platformOrder':
            this.ymsPlatformOrderId = obj.ymsPlatformOrderId;
            this.handlePlatformShippingWarehouseData(obj);
            break;
        }
      }
      this.shippingWarehouseModal = true;
    },
    // 处理平台订单的货品数据
    handlePlatformShippingWarehouseData(obj) {
      let ymsProductGoodsIds = [];
      let list = [];
      let ymsPlatformOrderTransactions = obj.ymsPlatformOrderTransactions || [];
      ymsPlatformOrderTransactions.map((item) => {
        item.ymsProductGoodsId = item.businessId;
        if (item.ymsProductGoodsId) {
          ymsProductGoodsIds.push(item.ymsProductGoodsId);
        }
      });
      if (ymsProductGoodsIds.length > 0) {
        getProductShippingWarehouseInventory(ymsProductGoodsIds).then((data) => {
          this.getProductInfoByIds(ymsProductGoodsIds, ymsPlatformOrderTransactions, false, false, false).then((newList) => {
            if (newList.length > 0) {
              newList.map((item) => {
                let ymsWarehouseList = [];
                const _productInfo = item._productInfo;
                if (_productInfo) {
                  let specificationsList = [];
                  let {_spuInfo, ymsSku, productGoodsSpecificationList} = _productInfo;
                  let {ymsProductId, name, primaryImage, ymsSpu} = _spuInfo;
                  if (productGoodsSpecificationList.length > 0) {
                    specificationsList = productGoodsSpecificationList.map((item) => {
                      return item.value;
                    });
                  }
                  let specifications = specificationsList.join(' • ');
                  data.map((ele) => {
                    if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                      let list = ele.productDeliverWarehouseResultBos || [];
                      ymsWarehouseList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                    }
                  });
                  list.push({
                    ...item,
                    ymsProductId,
                    name,
                    primaryImage,
                    ymsSpu,
                    ymsSku,
                    specifications,
                    ymsWarehouseId: item.ymsWarehouseId,
                    ymsWarehouseList: ymsWarehouseList,
                  });
                }
              });
              this.shippingWarehouseData = list;
            }
          });
        });
      }
    },
    // 确定按钮
    shippingWarehouseBtn() {
      let v = this;
      let query = {
        ymsPlatformOrderId: v.ymsPlatformOrderId,
        updateTransactionWarehouseBoList: []
      };
      switch (v.operationType) {
        case 'platformDetails':
          query.updateTransactionWarehouseBoList = [{
            ymsPlatformOrderTransactionId: v.ymsPlatformOrderTransactionId,
            ymsWarehouseId: v.ymsWarehouseId
          }];
          if (v.ymsWarehouseId) {
            handleData(query);
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005941'));
            return false;
          }
          break;
        case 'platformOrder':
          let talg = v.shippingWarehouseData.every((item) => item.ymsWarehouseId);
          if (talg) {
            query.updateTransactionWarehouseBoList = v.shippingWarehouseData.map((item) => {
              return {
                ymsPlatformOrderTransactionId: item.ymsPlatformOrderTransactionId,
                ymsWarehouseId: item.ymsWarehouseId
              };
            });
            handleData(query);
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005942'));
            return false;
          }
          break;
      }

      function handleData(query) {
        v.axios.put(api.put_ymsPlatformOrder_updateOrderWarehouse, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
            v.shippingWarehouseModal = false;
            v.$emit('updateData', true);
          }
        });
      }
    },
    // 展开选择发货仓下拉框
    openChange(value, obj, index) {
      let ymsWarehouseList = obj.ymsWarehouseList || [];
      if (value && ymsWarehouseList.length <= 0) {
        getProductShippingWarehouseInventory([obj.ymsProductGoodsId]).then((data) => {
          if (data.length > 0) {
            data.map((item) => {
              if (item.ymsProductGoodsId === obj.ymsProductGoodsId) {
                let list = item.productDeliverWarehouseResultBos || [];
                let newData = list.sort((a, b) => b.availableNumber - a.availableNumber);
                this.$set(this.shippingWarehouseData[index], 'ymsWarehouseList', newData);
                this.$forceUpdate();
              }
            });
          }
        });
      }
    },
    // 监听弹窗
    shippingWarehouseChange(value) {
      if (!value) {
        this.ymsWarehouseId = null;
        this.shippingWarehouseList = [];
        this.operationType = null;
        this.shippingWarehouseTitle = '';
        this.shippingWarehouseWidth = 500;
        this.ymsPlatformOrderId = null;
        this.ymsPlatformOrderTransactionId = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles {
  .shippingWarehouse_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 16px;
    padding-bottom: 16px;

    .img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #E2E2E2;
    }

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>
